'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _propertiesByContentT, _defaultContentValues, _entityKeys;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ROW = exports.ROW = 'row',
  ROW_WITH_STRIPE = exports.ROW_WITH_STRIPE = 'row with stripe',
  EXPANDABLE_ROW = exports.EXPANDABLE_ROW = 'expandable row',
  TEXT = exports.TEXT = 'text',
  LINK = exports.LINK = 'link',
  IMAGE_WITH_LINK = exports.IMAGE_WITH_LINK = 'image with link',
  BUTTON = exports.BUTTON = 'button',
  COLUMN = exports.COLUMN = 'column',
  COUNTDOWN = exports.COUNTDOWN = 'countdown',
  EVENT_NAME = exports.EVENT_NAME = 'event name',
  EVENT_ADDRESS = exports.EVENT_ADDRESS = 'event address',
  SPEAKER_LIST = exports.SPEAKER_LIST = 'speaker list',
  SPEAKER_TILES = exports.SPEAKER_TILES = 'speaker tiles',
  SPEAKER_SQUARE_HOVER = exports.SPEAKER_SQUARE_HOVER = 'speaker square hover',
  SPEAKER_CAROUSEL = exports.SPEAKER_CAROUSEL = 'speaker carousel',
  SPONSOR_LOGOS = exports.SPONSOR_LOGOS = 'sponsor logos',
  SPONSOR_CARDS = exports.SPONSOR_CARDS = 'sponsor cards',
  WORKSHOP_LIST = exports.WORKSHOP_LIST = 'activity list',
  WORKSHOP_ZEBRA = exports.WORKSHOP_ZEBRA = 'activity zebra',
  WORKSHOP_RECTANGLES = exports.WORKSHOP_RECTANGLES = 'activity rectangles',
  WORKSHOP_DROPDOWN = exports.WORKSHOP_DROPDOWN = 'activity dropdown',
  WORKSHOPS_BY_NAME = exports.WORKSHOPS_BY_NAME = 'activity names',
  REGISTRATION_IFRAME = exports.REGISTRATION_IFRAME = 'registration iframe',
  RESUME_REGISTRATION = exports.RESUME_REGISTRATION = 'resume registration',
  REGISTRATION_TYPE_CARDS = exports.REGISTRATION_TYPE_CARDS = 'registration type cards',
  REGISTRATION_TYPE_TABLE = exports.REGISTRATION_TYPE_TABLE = 'registration type table',
  REGISTRATION_TYPE_MULTICOLOR = exports.REGISTRATION_TYPE_MULTICOLOR = 'registration type multicor',
  REGISTRATION_TYPE_ROWS = exports.REGISTRATION_TYPE_ROWS = 'registration type rows',
  NETWORKING_LOGIN_LINK = exports.NETWORKING_LOGIN_LINK = 'networking login link',
  NAVBAR = exports.NAVBAR = 'navbar',
  FOOTER = exports.FOOTER = 'footer',
  FOOTER_INLINE = exports.FOOTER_INLINE = 'footer inline',
  SIMPLE_FOOTER = exports.SIMPLE_FOOTER = 'simple footer',
  IMAGE = exports.IMAGE = 'image',
  MAP = exports.MAP = 'map',
  EXHIBITORS_GRID = exports.EXHIBITORS_GRID = 'Stand reservations grid',
  EXHIBITORS_LOGOS = exports.EXHIBITORS_LOGOS = 'Stand reservations Logos',
  HTML = exports.HTML = 'html',
  IFRAME = exports.IFRAME = 'iframe',
  CAROUSEL = exports.CAROUSEL = 'carousel',
  VIDEO_PLAYER = exports.VIDEO_PLAYER = 'Video player',
  CONTACT_FORM = exports.CONTACT_FORM = 'contact form',
  B2B_MATCHMAKING_GRID = exports.B2B_MATCHMAKING_GRID = 'B2B Matchmaking',
  COOKIE_CONSENT_SMALL = exports.COOKIE_CONSENT_SMALL = 'Cookie Consent';
var getDestinationEmailForContact = function getDestinationEmailForContact(state) {
  var events = state.site.entities.events;
  var event = events[Object.keys(events)[0]];
  return event.senderEmail;
};
var propertiesByContentType = exports.propertiesByContentType = (_propertiesByContentT = {}, _defineProperty(_propertiesByContentT, TEXT, {
  color: {
    type: 'css',
    value: 'black',
    editable: true
  },
  linkColor: {
    type: 'custom',
    value: 'cyan',
    editable: true
  },
  textAlign: {
    type: 'css',
    value: 'left',
    editable: true
  },
  fontSize: {
    type: 'css',
    value: '1em',
    editable: true
  },
  mobileFontSize: {
    type: 'custom',
    value: '1em',
    editable: true
  },
  fontFamily: {
    type: 'css',
    value: 'inherit',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, COLUMN, {
  small: {
    type: 'responsive',
    value: 12,
    editable: true
  },
  medium: {
    type: 'responsive',
    value: 6,
    editable: true
  },
  large: {
    type: 'responsive',
    value: 4,
    editable: true
  },
  offsetSmall: {
    type: 'responsive',
    value: 0,
    editable: true
  },
  offsetMedium: {
    type: 'responsive',
    value: 0,
    editable: true
  },
  offsetLarge: {
    type: 'responsive',
    value: 0,
    editable: true
  },
  backgroundImage: {
    type: 'css',
    value: '',
    editable: true
  },
  backgroundRepeat: {
    type: 'css',
    value: 'no-repeat'
  },
  backgroundSize: {
    type: 'css',
    value: 'cover'
  },
  backgroundPosition: {
    type: 'css',
    value: 'center'
  },
  backgroundColor: {
    type: 'css',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  allowedContents: {
    type: 'content',
    value: [ROW, EXPANDABLE_ROW, TEXT, IMAGE, LINK, IMAGE_WITH_LINK, BUTTON, HTML, EVENT_NAME, EVENT_ADDRESS, COUNTDOWN, REGISTRATION_IFRAME],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, ROW, {
  backgroundImage: {
    type: 'css',
    value: '',
    editable: true
  },
  backgroundRepeat: {
    type: 'css',
    value: 'no-repeat'
  },
  backgroundSize: {
    type: 'css',
    value: 'cover'
  },
  backgroundPosition: {
    type: 'css',
    value: 'center'
  },
  backgroundColor: {
    type: 'css',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  allowedContents: {
    type: 'content',
    value: [COLUMN],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, ROW_WITH_STRIPE, {
  accentColor: {
    type: 'custom',
    value: '#B52D38',
    editable: true
  },
  backgroundColor: {
    type: 'css',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, EXPANDABLE_ROW, {
  backgroundImage: {
    type: 'css',
    value: '',
    editable: true
  },
  backgroundRepeat: {
    type: 'css',
    value: 'no-repeat'
  },
  backgroundSize: {
    type: 'css',
    value: 'cover'
  },
  backgroundPosition: {
    type: 'css',
    value: 'center'
  },
  backgroundColor: {
    type: 'css',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  titleColor: {
    type: 'custom',
    value: '#000000',
    editable: true
  },
  titleFontSize: {
    type: 'custom',
    value: '1em',
    editable: true
  },
  mobileTitleFontSize: {
    type: 'custom',
    value: '0.8em',
    editable: true
  },
  expandedByDefault: {
    type: 'custom',
    value: true,
    editable: true
  },
  buttonColor: {
    type: 'custom',
    value: '#000000',
    editable: true
  },
  allowedContents: {
    type: 'content',
    value: [COLUMN],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, LINK, {
  href: {
    type: 'custom',
    value: '#',
    editable: true
  },
  target: {
    type: 'custom',
    value: '_self',
    editable: true
  },
  padding: {
    type: 'css',
    value: '1rem'
  },
  allowedContents: {
    type: 'content',
    value: [TEXT, IMAGE],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, IMAGE_WITH_LINK, {
  href: {
    type: 'custom',
    value: '#',
    editable: true
  },
  target: {
    type: 'custom',
    value: '_self',
    editable: true
  },
  src: {
    type: 'custom',
    value: '',
    editable: true
  },
  alternateText: {
    type: 'custom',
    value: '',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, BUTTON, {
  href: {
    type: 'custom',
    value: '#',
    editable: true
  },
  target: {
    type: 'custom',
    value: '_self',
    editable: true
  },
  verticalPadding: {
    type: 'custom',
    value: '0.5rem',
    editable: true
  },
  horizontalPadding: {
    type: 'custom',
    value: '1.5rem',
    editable: true
  },
  color: {
    type: 'custom',
    value: '#fff',
    editable: true
  },
  hoveredColor: {
    type: 'custom',
    value: '#fff',
    editable: true
  },
  borderColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  hoveredBorderColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  backgroundColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0.8)',
    editable: true
  },
  hoveredBackgroundColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 1)',
    editable: true
  },
  borderRadius: {
    type: 'custom',
    value: '0.2rem',
    editable: true
  },
  alignSelf: {
    type: 'css',
    value: 'center',
    editable: true
  },
  fontSize: {
    type: 'css',
    value: '1em',
    editable: true
  },
  mobileFontSize: {
    type: 'custom',
    value: '1em',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, NETWORKING_LOGIN_LINK, {
  verticalPadding: {
    type: 'custom',
    value: '0.5rem',
    editable: true
  },
  horizontalPadding: {
    type: 'custom',
    value: '1.5rem',
    editable: true
  },
  color: {
    type: 'custom',
    value: '#fff',
    editable: true
  },
  hoveredColor: {
    type: 'custom',
    value: '#fff',
    editable: true
  },
  borderColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  hoveredBorderColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0)',
    editable: true
  },
  backgroundColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0.8)',
    editable: true
  },
  hoveredBackgroundColor: {
    type: 'custom',
    value: 'rgba(0, 0, 0, 1)',
    editable: true
  },
  borderRadius: {
    type: 'custom',
    value: '0.2rem',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, WORKSHOP_LIST, {
  showFilters: {
    type: 'custom',
    value: false,
    editable: true
  },
  displayedWorkshopCategories: {
    type: 'custom',
    value: [],
    editable: true
  },
  showCategories: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, WORKSHOP_ZEBRA, {
  showFilters: {
    type: 'custom',
    value: false,
    editable: true
  },
  displayedWorkshopCategories: {
    type: 'custom',
    value: [],
    editable: true
  },
  showCategories: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, WORKSHOP_RECTANGLES, {
  showFilters: {
    type: 'custom',
    value: false,
    editable: true
  },
  displayedWorkshopCategories: {
    type: 'custom',
    value: [],
    editable: true
  },
  showCategories: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, WORKSHOP_DROPDOWN, {
  showFilters: {
    type: 'custom',
    value: false,
    editable: true
  },
  displayedWorkshopCategories: {
    type: 'custom',
    value: [],
    editable: true
  },
  showCategories: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, WORKSHOPS_BY_NAME, {
  // showCategories: {type: 'custom', value: false, editable: true},
}), _defineProperty(_propertiesByContentT, SPONSOR_LOGOS, {}), _defineProperty(_propertiesByContentT, SPONSOR_CARDS, {}), _defineProperty(_propertiesByContentT, SPEAKER_LIST, {
  hideSearchField: {
    type: 'custom',
    value: true,
    editable: true
  },
  buttonColor: {
    type: 'custom',
    value: '#FDAB2B',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, SPEAKER_TILES, {
  hideSearchField: {
    type: 'custom',
    value: true,
    editable: true
  },
  buttonColor: {
    type: 'custom',
    value: '#FDAB2B',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, SPEAKER_SQUARE_HOVER, {
  hideSearchField: {
    type: 'custom',
    value: true,
    editable: true
  },
  buttonColor: {
    type: 'custom',
    value: '#FDAB2B',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, SPEAKER_CAROUSEL, {}), _defineProperty(_propertiesByContentT, EXHIBITORS_GRID, {
  hideSearchBar: {
    type: 'custom',
    value: false,
    editable: true
  },
  hideZoneFilter: {
    type: 'custom',
    value: false,
    editable: true
  },
  hideCompanyFilter: {
    type: 'custom',
    value: false,
    editable: true
  },
  hideCategoryFilter: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, EXHIBITORS_LOGOS, {
  hideSearchBar: {
    type: 'custom',
    value: false,
    editable: true
  },
  hideZoneFilter: {
    type: 'custom',
    value: false,
    editable: true
  },
  hideCompanyFilter: {
    type: 'custom',
    value: false,
    editable: true
  },
  hideCategoryFilter: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, B2B_MATCHMAKING_GRID, {}), _defineProperty(_propertiesByContentT, COOKIE_CONSENT_SMALL, {}), _defineProperty(_propertiesByContentT, HTML, {
  html: {
    type: 'custom',
    value: '<div style="padding: 4rem 2rem; text-align: center;">\n  <h1>Insert your custom HTML here.</h1>\n</div>',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, IFRAME, {
  iframeSrc: {
    type: 'custom',
    value: '',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, NAVBAR, {
  logoPosition: {
    type: 'custom',
    value: 'left',
    editable: true
  },
  navPosition: {
    type: 'custom',
    value: 'static',
    editable: true
  },
  fontSize: {
    type: 'css',
    value: 14,
    editable: true
  },
  navItemMargin: {
    type: 'custom',
    value: '0 5px',
    editable: true
  },
  socialMedia: {
    type: 'custom',
    value: false,
    editable: true
  },
  facebookLink: {
    type: 'custom',
    value: 'https://facebook.com',
    editable: true
  },
  twitterLink: {
    type: 'custom',
    value: 'https://twitter.com',
    editable: true
  },
  linkedInLink: {
    type: 'custom',
    value: 'https://linkedin.com',
    editable: true
  },
  instagramLink: {
    type: 'custom',
    value: 'https://instagram.com',
    editable: true
  },
  youTubeLink: {
    type: 'custom',
    value: 'https://youtube.com',
    editable: true
  },
  socialMediaIconColor: {
    type: 'custom',
    value: '#947f42',
    editable: true
  },
  linkSelector: {
    type: 'custom',
    value: [],
    editable: true
  },
  homeUrl: {
    type: 'custom',
    value: '',
    editable: true
  },
  languageSelector: {
    type: 'custom',
    value: false,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, FOOTER, {
  socialMedia: {
    type: 'custom',
    value: false,
    editable: true
  },
  facebookLink: {
    type: 'custom',
    value: 'https://facebook.com',
    editable: true
  },
  twitterLink: {
    type: 'custom',
    value: 'https://twitter.com',
    editable: true
  },
  linkedInLink: {
    type: 'custom',
    value: 'https://linkedin.com',
    editable: true
  },
  instagramLink: {
    type: 'custom',
    value: 'https://instagram.com',
    editable: true
  },
  youTubeLink: {
    type: 'custom',
    value: 'https://youtube.com',
    editable: true
  },
  socialMediaIconColor: {
    type: 'custom',
    value: '#947f42',
    editable: true
  },
  linkSelector: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, FOOTER_INLINE, {
  socialMedia: {
    type: 'custom',
    value: false,
    editable: true
  },
  facebookLink: {
    type: 'custom',
    value: 'https://facebook.com',
    editable: true
  },
  twitterLink: {
    type: 'custom',
    value: 'https://twitter.com',
    editable: true
  },
  linkedInLink: {
    type: 'custom',
    value: 'https://linkedin.com',
    editable: true
  },
  instagramLink: {
    type: 'custom',
    value: 'https://instagram.com',
    editable: true
  },
  youTubeLink: {
    type: 'custom',
    value: 'https://youtube.com',
    editable: true
  },
  socialMediaIconColor: {
    type: 'custom',
    value: '#947f42',
    editable: true
  },
  linkSelector: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, SIMPLE_FOOTER, {
  socialMedia: {
    type: 'custom',
    value: false,
    editable: true
  },
  facebookLink: {
    type: 'custom',
    value: 'https://facebook.com',
    editable: true
  },
  twitterLink: {
    type: 'custom',
    value: 'https://twitter.com',
    editable: true
  },
  linkedInLink: {
    type: 'custom',
    value: 'https://linkedin.com',
    editable: true
  },
  instagramLink: {
    type: 'custom',
    value: 'https://instagram.com',
    editable: true
  },
  youTubeLink: {
    type: 'custom',
    value: 'https://youtube.com',
    editable: true
  },
  socialMediaIconColor: {
    type: 'custom',
    value: '#586f66',
    editable: true
  },
  linkSelector: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, IMAGE, {
  src: {
    type: 'custom',
    value: '',
    editable: true
  },
  alternateText: {
    type: 'custom',
    value: '',
    editable: true
  },
  width: {
    type: 'css',
    value: '100%'
  },
  objectFit: {
    type: 'css',
    value: 'contain'
  },
  flex: {
    type: 'css',
    value: '0 0 auto'
  }
}), _defineProperty(_propertiesByContentT, MAP, {}), _defineProperty(_propertiesByContentT, COUNTDOWN, {
  countdownNumberColor: {
    type: 'custom',
    value: '#FFFFFF',
    editable: true
  },
  countdownTextColor: {
    type: 'custom',
    value: '#FFFFFF',
    editable: true
  },
  countdownFontSize: {
    type: 'custom',
    value: 1,
    editable: true
  },
  textAlign: {
    type: 'css',
    value: 'left',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, EVENT_NAME, {}), _defineProperty(_propertiesByContentT, EVENT_ADDRESS, {}), _defineProperty(_propertiesByContentT, CAROUSEL, {
  carouselSlides: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, VIDEO_PLAYER, {
  videoUrl: {
    type: 'custom',
    value: '',
    editable: true
  },
  aspectRatio: {
    type: 'custom',
    value: '4:3',
    editable: true
  }
}), _defineProperty(_propertiesByContentT, CONTACT_FORM, {
  destinationEmail: {
    type: 'custom',
    value: getDestinationEmailForContact,
    editable: true
  }
}), _defineProperty(_propertiesByContentT, REGISTRATION_TYPE_CARDS, {
  displayedAttendeeTypes: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, REGISTRATION_TYPE_TABLE, {
  displayedAttendeeTypes: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, REGISTRATION_TYPE_MULTICOLOR, {
  displayedAttendeeTypes: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _defineProperty(_propertiesByContentT, REGISTRATION_TYPE_ROWS, {
  displayedAttendeeTypes: {
    type: 'custom',
    value: [],
    editable: true
  }
}), _propertiesByContentT);
var defaultContentValues = exports.defaultContentValues = (_defaultContentValues = {}, _defineProperty(_defaultContentValues, TEXT, '<p>Edit this text</p>'), _defineProperty(_defaultContentValues, BUTTON, '<p>Edit this link</p>'), _defineProperty(_defaultContentValues, EXPANDABLE_ROW, '<h2>Edit this title</h2>'), _defaultContentValues);

// if the value is an Array, the first key will be used for pagination purposes
var entityKeys = exports.entityKeys = (_entityKeys = {}, _defineProperty(_entityKeys, B2B_MATCHMAKING_GRID, ['business_conference_participants', 'business_conference_participant_types', 'attendee_type_custom_fields', 'business_conference_profile_fields', 'events', 'business_conferences', 'attendees', 'attendee_types']), _defineProperty(_entityKeys, EXHIBITORS_GRID, ['stand_reservations', 'companies', 'stands', 'zones', 'events', 'stand_categories', 'custom_fields']), _defineProperty(_entityKeys, EXHIBITORS_LOGOS, ['stand_reservations', 'companies', 'stands', 'zones', 'events', 'stand_categories', 'custom_fields']), _defineProperty(_entityKeys, SPEAKER_LIST, 'speakers'), _defineProperty(_entityKeys, SPEAKER_TILES, 'speakers'), _defineProperty(_entityKeys, SPEAKER_SQUARE_HOVER, 'speakers'), _defineProperty(_entityKeys, SPEAKER_CAROUSEL, 'speakers'), _defineProperty(_entityKeys, SPONSOR_LOGOS, ['sponsors', 'sponsor_categories']), _defineProperty(_entityKeys, SPONSOR_CARDS, ['sponsors', 'sponsor_categories']), _defineProperty(_entityKeys, WORKSHOP_LIST, ['workshops', 'speakers', 'events', 'workshop_categories']), _defineProperty(_entityKeys, WORKSHOP_ZEBRA, ['workshops', 'speakers', 'events', 'workshop_categories']), _defineProperty(_entityKeys, WORKSHOP_RECTANGLES, ['workshops', 'speakers', 'events', 'workshop_categories']), _defineProperty(_entityKeys, WORKSHOP_DROPDOWN, ['workshops', 'speakers', 'events', 'workshop_categories']), _defineProperty(_entityKeys, WORKSHOPS_BY_NAME, ['workshops', 'speakers', 'events', 'workshop_categories']), _defineProperty(_entityKeys, REGISTRATION_IFRAME, 'events'), _defineProperty(_entityKeys, RESUME_REGISTRATION, 'events'), _defineProperty(_entityKeys, NETWORKING_LOGIN_LINK, 'events'), _defineProperty(_entityKeys, REGISTRATION_TYPE_CARDS, ['events', 'attendee_types']), _defineProperty(_entityKeys, REGISTRATION_TYPE_TABLE, ['events', 'attendee_types']), _defineProperty(_entityKeys, REGISTRATION_TYPE_MULTICOLOR, ['events', 'attendee_types']), _defineProperty(_entityKeys, REGISTRATION_TYPE_ROWS, ['events', 'attendee_types']), _defineProperty(_entityKeys, COUNTDOWN, 'events'), _defineProperty(_entityKeys, EVENT_NAME, 'events'), _defineProperty(_entityKeys, EVENT_ADDRESS, 'events'), _defineProperty(_entityKeys, NAVBAR, 'events'), _defineProperty(_entityKeys, FOOTER, 'events'), _defineProperty(_entityKeys, FOOTER_INLINE, 'events'), _defineProperty(_entityKeys, SIMPLE_FOOTER, 'events'), _defineProperty(_entityKeys, COOKIE_CONSENT_SMALL, 'events'), _defineProperty(_entityKeys, MAP, ['events', 'pois']), _defineProperty(_entityKeys, CONTACT_FORM, 'events'), _entityKeys);